import { apiClient } from '@app/lib'
import { type SugarPaymentReportsPaginatedResponse } from '@app/types'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useSession } from 'next-auth/react'

export const usePaymentReports = (page: number = 1) => {
  const session = useSession()

  return useQuery({
    enabled: session.status === 'authenticated',
    placeholderData: keepPreviousData,
    queryKey: ['paymentReports', page],
    queryFn: async () => {
      const { data } = await apiClient.get<SugarPaymentReportsPaginatedResponse>('/api/payment-reports', {
        params: {
          page: Math.max(1, page)
        }
      })

      return data
    }
  })
}
